import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { FsaPermission } from '../../Models/Models/Company/FsaPermission';

declare var IS_RUNNING_IN_APP_POOL;

export class CompanyFsaPermissionsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(company: string, fsaRegulatedActivityName: string): Promise<Array<FsaPermission>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Company/CompanyFsaPermissions/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { company: company, fsaRegulatedActivityName: fsaRegulatedActivityName }

    return AjaxWrapper.get<Array<FsaPermission>, any>(url, data);
  }
}

